import { Component, OnInit } from '@angular/core';
import { IStatsTileDefinition } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/interfaces/tiles/definitions/stats-tile-definition.interface';
import { FilterConditionType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-condition-type.enum';
import { FilterOperatorType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-operator-type.enum';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-monthly-report',
  template: `
    <suvo-bi-tile-wrapper fxFlex="1 1" class="dashboard-tile" [tileInstance]="tileInstance" />
  `,
})
export class MonthlyReportComponent implements OnInit {
  tileInstance: IStatsTileDefinition;

  ngOnInit() {
    const nowDateTime = DateTime.utc();
    const startOfMonth = nowDateTime.startOf('month');

    this.tileInstance = {
      tileType: 'stats',
      title: 'This Month',
      statDefinitions: [
        {
          title: 'Samples Finalised',
          recipe: {
            dataSource: 'samples',
            fullRoute: 'sample-reports',
            metric: 'count',
            filters: {
              name: 'Report Filters',
              query: {
                op: FilterOperatorType.And,
                rules: [
                  {
                    key: 'finalisedAt',
                    con: [
                      {
                        type: FilterConditionType.GreaterThanEquals,
                        val: startOfMonth.toISO(),
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
        {
          title: 'Tows Finalised',
          recipe: {
            dataSource: 'tows',
            fullRoute: 'recording-event-reports',
            metric: 'count',
            extraParams: {
              type: 'tow',
            },
            filters: {
              name: 'Report Filters',
              query: {
                op: FilterOperatorType.And,
                rules: [
                  {
                    key: 'submittedAt',
                    con: [
                      {
                        type: FilterConditionType.GreaterThanEquals,
                        val: startOfMonth.toISO(),
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
      ],
      canView: true,
      backgroundColor: 'white',
    };
  }
}
